export default __webpack_public_path__ + "static/media/baseline-edit-purple-24px.842d6312.svg";